/**
 * @generated SignedSource<<998509ff9a778f6e00e63100d80ace9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentQrCode_pixQrCode$data = {
  readonly company: {
    readonly projectType: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"PaymentCompanyLogo_company" | "PaymentCompanySupport_company">;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentQrCodeContent_pixQrCode" | "PaymentTestAccountBanner_pixQrCode">;
  readonly " $fragmentType": "PaymentQrCode_pixQrCode";
};
export type PaymentQrCode_pixQrCode$key = {
  readonly " $data"?: PaymentQrCode_pixQrCode$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentQrCode_pixQrCode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentQrCode_pixQrCode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectType",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentCompanyLogo_company"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentCompanySupport_company"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentTestAccountBanner_pixQrCode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentQrCodeContent_pixQrCode"
    }
  ],
  "type": "PixQrCode",
  "abstractKey": null
};

(node as any).hash = "dbd200ced19185c5ff2e8c6f9746ffe4";

export default node;
